import { AllocationRule } from 'further-types/lp/allocations';
import {
  ConsiderationType,
  PartialRealisationAllocationLogic,
  RealisationTypes,
} from 'further-types/lp/realisation';

export const PartialRealisationAllocationLogicLabels = {
  [PartialRealisationAllocationLogic.ProRata]: 'Pro rata',
  [PartialRealisationAllocationLogic.FIFO]: 'FIFO',
  [PartialRealisationAllocationLogic.LIFO]: 'LIFO',
  [PartialRealisationAllocationLogic.Manual]: 'Manual',
};

export const ConsiderationTypeLabels = {
  [ConsiderationType.CashAndWithholdingTax]: 'Cash (and withholding tax)',
  [ConsiderationType.Equity]: 'Equity',
};

export const getInvestorAllocationTypeLabels = (
  allocationType: AllocationRule,
  assetName: string,
) => {
  switch (allocationType) {
    case AllocationRule.Manual:
      return 'Manual';
    case AllocationRule.PerOriginalInvestment:
      return `Per original investment(s) into ${assetName}`;
    default:
      return allocationType;
  }
};

export const RealisationTypeLabels = {
  [RealisationTypes.RealisationCreated]: 'Realisation',
};
